import "@/App.css";
import { HeroSection } from "./components/landing/HeroSection";
import { BenefitsSection } from "./components/landing/BenefitsSection";
import { ProgramSection } from "./components/landing/ProgramSection";
import { AboutSection } from "./components/landing/AboutSection";
import { TestimonialsSection } from "./components/landing/TestimonialsSection";
import { FreeClassSection } from "./components/landing/FreeClassSection";
import { PricingSection } from "./components/landing/PricingSection";
import { LocationSection } from "./components/landing/LocationSection";
import { FAQSection } from "./components/landing/FAQSection";
import { CTAFinalSection } from "./components/landing/CTAFinalSection";
import { Footer } from "./components/landing/Footer";
import { InstagramSection } from "./components/landing/InstagramSection";
import { WhatsAppFloat } from "./components/landing/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <HeroSection />
      <BenefitsSection />
      <ProgramSection />
      <AboutSection />
      <TestimonialsSection />
      <PricingSection />
      <FreeClassSection />
      <InstagramSection />
      <LocationSection />
      <FAQSection />
      <CTAFinalSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
